import { createContext, Dispatch, useContext } from "react";
import { Graph_QL } from "../../../Services";

/* eslint-disable */
export enum currentContentTypes {
  location = "location",
  station = "station"
}

export enum currentSubContentTypes {
  overview = "overview",
  settings = "settings"
}

export enum currentInnerContentTypes {
  stations = "stations",
  feeding = "feeding",
  logs = "logs",
  locations = "locations",
  animals = "animals",
}

export enum IModalContextEnum {
  currentContent = "currentContent",
  currentSubContent = "currentSubContent",
  currentInnerContent = "currentInnerContent",
  activeLocation = "activeLocation",
  activeStation = "activeStation",
  message = "message",
  error = "error",
}
/* eslint-enable */

export type IModalContext = {
  farm: string;
  domain: string;
  connection: Graph_QL.Connection;

  currentContent?: currentContentTypes;
  currentSubContent?: currentSubContentTypes;
  currentInnerContent?: currentInnerContentTypes;

  activeLocation?: number;
  activeStation?: number;

  message?: string;

  error: { Elementid: number, errorText: string };
};

export type ModalDispatcherT = Deep_Partial<IModalContext>;

type ModalContexter = {
  state: IModalContext,
  dispatch: Dispatch<ModalDispatcherT>
}

export const ModalContext = createContext<ModalContexter | undefined>(undefined);

export function ModalReducer(state: IModalContext, action: ModalDispatcherT) {
  let ResultState = { ...state };
  Object.entries(action).forEach(([type, payload], index) => {
    switch (type) {
      case IModalContextEnum.currentContent: {
        ResultState = {
          ...ResultState,
          currentContent: payload as currentContentTypes | undefined,
        };
        break;
      }
      case IModalContextEnum.currentSubContent: {
        ResultState = {
          ...ResultState,
          currentSubContent: payload as currentSubContentTypes | undefined,
        };
        break;
      }
      case IModalContextEnum.currentInnerContent: {
        ResultState = {
          ...ResultState,
          currentInnerContent: payload as currentInnerContentTypes | undefined,
        };
        break;
      }
      case IModalContextEnum.activeLocation: {
        ResultState = {
          ...ResultState,
          activeLocation: payload as number,
        };
        break;
      }
      case IModalContextEnum.activeStation: {
        ResultState = {
          ...ResultState,
          activeStation: payload as number,
        };
        break;
      }
      case IModalContextEnum.message: {
        ResultState = {
          ...ResultState,
          message: payload as string,
        };
        break;
      }
      case IModalContextEnum.error:
        ResultState = {
          ...ResultState,
          error: payload as IModalContext["error"]
        };
        break;

      default:
        console.error(`Unhandled action type: ${type}`);
        break;
    }
  });
  return ResultState;
}


export const useModalContext = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModalContext must be used within a ModalProvider");
  }
  return context;
};